const toPlotly = (value) => {
  switch (value) {
    case "step-after":
      return "hv";
    default:
      return value;
  }
};
export default toPlotly;
